import React from 'react';

import { faClockRotateLeft } from '@fortawesome/pro-solid-svg-icons';

import EmptyState from 'components/empty_state';

const HistoryEmptyState = () => {

  return <React.Fragment>
    <EmptyState
      header="No history to display"
      icon={faClockRotateLeft}
    />
  </React.Fragment>;
};

export default HistoryEmptyState;
